import React, { useEffect, useRef, useState } from "react"
import AdminDialog from "./AdminDialog"
import { TextArea, TextBox } from "devextreme-react";
import SelectBox from "../common/CustomSelectBox"
import TagBox from "../common/CustomTagBox"
import { useSelector } from "react-redux";
import { selectEmailRecipients, selectTemplateTypes } from "../../redux/templates/selectors";
import { SmsFormTypeIds } from "../../Constantes/smsFormTypes";
import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles({
    label: {
        color: "#333"
    },
  });

const initialData = {
    name: "",
    templateCode: "",
    emailSubject: "",
    templateTypeId: null,
    text: "",
    recipients: null,
    recipientsCC : null
}

function TemplatesDialogue(props){

const {operation, data, open, handleDialogClose, onSubmitOperation} = props;
const [editData, setEditData] = useState(initialData);
const templateTypes = useSelector(selectTemplateTypes)
const emailRecipients = useSelector(selectEmailRecipients)
const classes = useStyles();
const recipientsTagbox = useRef(null);
const recipientsCCTagbox = useRef(null);
const title = operation === "create" ? "Adicionar plantilla" : operation === "edit" ? "Editar plantilla" : "Eliminar plantilla"


useEffect(()=>{
    if(open && data){
        setEditData(data)
    } else {
        setEditData(initialData)
    }

},[data, open])

function handleEditField(key, value){
    setEditData(editData=>({...editData, [key]: value}))
}

function handleChangeType(value){
    if(value !== SmsFormTypeIds.internal_email){
        handleEditField("recipients", null)
        handleEditField("recipientsCC", null)
        recipientsTagbox.current?.instance?.reset();
        recipientsCCTagbox.current?.instance?.reset();
    }
    if(value === SmsFormTypeIds.sms){
        handleEditField("subject", "")
    }
    handleEditField("templateTypeId", value)
}

function handleChangeRecipients(value){
    const updatedValues = value.length > 0 ? value : []
    handleEditField("recipients", updatedValues)
}

function handleChangeRecipientsCC(value){
    const updatedValues = value.length > 0 ? value : []
    handleEditField("recipientsCC", updatedValues)
}

const customItemCreating = (args)=>{
    if (!args.text) {
      args.customItem = null;
      return;
    }
    args.customItem = {emailRecipientId: 0 , emailAddress: args.text}
}


    return(
        <AdminDialog dialogSize={{height: "100%"}} operation = { operation } open = { open } onClose = { handleDialogClose } title = {title} 
                data = { editData } handleOnClick = { ()=>onSubmitOperation(editData) }>
                { operation === 'delete'
                    ?   <Typography>
                            {`Se va a eliminar la plantilla ${editData.name}.`}
                        </Typography>
                    : 
                        <div className="edit-values-wrapper">                  
                                <SelectBox
                                    label = {"Tipo"}
                                    dataSource = { templateTypes }
                                    value = { editData.templateTypeId}
                                    displayExpr = { "description" }
                                    valueExpr = { "id" }
                                    onValueChanged = { (e) => handleChangeType(e.value) }
                                    searchEnabled = { true }
                                    showClearButton= {false}
                                    >
                                </SelectBox>
                                <TextBox labelMode="floating" label = {"Nome"} style={{height: "3rem"}} value={editData.name} onValueChanged={(e)=>{handleEditField("name", e.value)}}/>
                                <TextArea label = {"Mensagem"} height={100} minHeight={35} value={editData.text} onValueChanged={(e)=>{handleEditField("text", e.value)}}/>
                                <TextBox labelMode="floating" label = {"Assunto"} disabled={editData.templateTypeId === SmsFormTypeIds.sms} style={{height: "3rem"}} value={editData.subject} onValueChanged={(e)=>{handleEditField("subject", e.value)}}/>
                                <TagBox
                                    label = {"Destinatários"}
                                    innerRef={recipientsTagbox}
                                    disabled={editData.templateTypeId !== SmsFormTypeIds.internal_email}
                                    dataSource = { emailRecipients}
                                    showClearButton = { true }
                                    defaultValue = {editData.recipients?.map(r=> r.emailAddress) || null}
                                    displayExpr = { "emailAddress" }
                                    valueExpr = { "emailAddress" }
                                    onValueChanged =  {(e)=>{handleChangeRecipients(e.value)}}
                                    searchEnabled = { true }
                                    hideSelectedItems
                                    acceptCustomValue
                                    onCustomItemCreating={customItemCreating}      
                                >
                                </TagBox>
                                <TagBox
                                    label={"Destinatários CC"}
                                    innerRef={recipientsCCTagbox}
                                    disabled={editData.templateTypeId !== SmsFormTypeIds.internal_email}
                                    dataSource = { emailRecipients}
                                    showClearButton = { true }
                                    defaultValue = {editData.recipientsCC?.map(rcc=> rcc.emailAddress) || null}
                                    displayExpr = { "emailAddress" }
                                    valueExpr = { "emailAddress" }
                                    onValueChanged =  {(e)=>{handleChangeRecipientsCC(e.value)}}
                                    searchEnabled = { true }
                                    hideSelectedItems
                                    acceptCustomValue
                                    onCustomItemCreating={customItemCreating}
                                >
                                </TagBox>
                        </div>
            }
        </AdminDialog>
    )

}

export {TemplatesDialogue}